export default theme => ({
    accordion: {
        border: `2px solid ${theme.palette.grey[200]}`,
        marginBottom: 18,

        '& .MuiButtonBase-root': {
            '& p': {
                margin: '0!important',
                fontWeight: 700,
                textTransform: 'capitalize',
                fontSize: 16
            }
        }
    },
    gallery: {
        display: 'grid',
        gap: 20,
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        fontWeight: 600,
        '& .image': {
            display: 'flex',
            flexDirection: 'column'
        },
        '& .timestamp': {
            marginTop: 10,
            fontSize: 14,
            color: theme.palette.grey[900]
        },
        '& .picture': {
            marginTop: 10
        },
        '& .cameraLable span': {
            fontWeight: 400
        }
    },
    empty: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        maxWidth: 615,
        margin: '0 auto',
        gap: 7,
        color: theme.palette.grey[900],
        letterSpacing: '0.1px',
        lineHeight: '22px',
        height: 260,
        '& .title': {
            fontWeight: 700,
            fontSize: 14
        },
        '& .text': {
            fontSize: 12
        }
    }
});
